/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Uno_Edu_Space_Sync_Chip1_AnswerInputs */



/**
* | output |
* | --- |
* | "Sync whenever the source has changed and you want those updates in your chats. The process is incremental, so it only fetches files that are new or modified." |
*
* @param {Uno_Edu_Space_Sync_Chip1_AnswerInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const uno_edu_space_sync_chip1_answer = /** @type {((inputs?: Uno_Edu_Space_Sync_Chip1_AnswerInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Uno_Edu_Space_Sync_Chip1_AnswerInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Synchronisieren Sie, sobald sich die Quelle geändert hat und Sie diese Aktualisierungen in Ihren Chats benötigen. Der Vorgang ist inkrementell und ruft nur neue oder geänderte Dateien ab.")
	return /** @type {LocalizedString} */ ("Sync whenever the source has changed and you want those updates in your chats. The process is incremental, so it only fetches files that are new or modified.")
});